import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Registros.css';

// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

const Registros = ({ clienteId }) => {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRegistros = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          throw new Error('Token de autenticação não encontrado');
        }
        
        // This API endpoint needs to be implemented in the backend
        const response = await axios.get(`${API_BASE_URL}/api/registros/cliente/${clienteId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setRegistros(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao buscar registros:', err);
        setError(err.response?.data?.message || err.message || 'Erro ao buscar registros do cliente');
        setLoading(false);
      }
    };

    if (clienteId) {
      fetchRegistros();
    }
  }, [clienteId]);

  if (loading) {
    return (
      <div className="loading-indicator">
        <div className="spinner"></div>
        <span>Carregando registros...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        <i className="fas fa-exclamation-triangle"></i>
        Erro: {error}
      </div>
    );
  }

  if (!registros || registros.length === 0) {
    return (
      <div className="info-message">
        <i className="fas fa-info-circle"></i>
        Nenhum registro encontrado para este cliente.
      </div>
    );
  }

  return (
    <div className="registros-container">
      <h3>
        <i className="fas fa-clipboard-list"></i>
        Registros do Cliente
      </h3>
      
      <div className="registros-table-wrapper">
        <table className="registros-table">
          <thead>
            <tr>
              <th>Número</th>
              <th>Data</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {registros.map(registro => (
              <tr key={registro._id}>
                <td>{registro.numero}</td>
                <td>{new Date(registro.data).toLocaleDateString('pt-BR')}</td>
                <td>{registro.tipo}</td>
                <td>
                  <span className={`status-badge status-${registro.status.toLowerCase()}`}>
                    {registro.status === 'pendente' && <i className="fas fa-clock"></i>}
                    {registro.status === 'andamento' && <i className="fas fa-spinner"></i>}
                    {registro.status === 'concluido' && <i className="fas fa-check-circle"></i>}
                    {registro.status === 'cancelado' && <i className="fas fa-times-circle"></i>}
                    {registro.status}
                  </span>
                </td>
                <td>
                  <button className="action-btn view-btn" title="Ver detalhes">
                    <i className="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Registros;